import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDashboardPreference } from '../../../shared/model/dashboard-preferences';
import { AppConstants } from '../../../shared/constants/constants';

@Injectable()
export class UserService {
  private BASE_URL = this.appconstants.API_BASE_URL_USER;

  constructor(private httpClient: HttpClient, private appconstants: AppConstants) { }


  getDashboardPreferences() {
    return this.httpClient.get<IDashboardPreference>(`${this.BASE_URL}/Applications/${this.appconstants.applicationId}/Preferences/Dashboard`);
  }

  setDashboardPreferences(dashboardPreference: IDashboardPreference) {
    return this.httpClient.put<IDashboardPreference>(`${this.BASE_URL}/Applications/${this.appconstants.applicationId}/Preferences/Dashboard`, dashboardPreference);
  }
}
